import { MonetaryAmount } from "../../../app/domain/monetary-amount";

export default function restoreBenefitBag({
  benefitBagConfig,
}: {
  benefitBagConfig: {
    accumulableAtPeriodEnd: boolean;
    allowedFor: { benefit: "string"; config: any }[];
    benefitBagConfigId: string;
    consumableFrom: string;
    limitAmount: MonetaryAmount;
    periodDurationInPayrolls: number;
    state: string;
    stateHistory: { state: "string"; timestamp: number }[];
  };
}) {
  const {
    benefitBagConfigId,
    periodDurationInPayrolls,
    consumableFrom,
    limitAmount,
    accumulableAtPeriodEnd,
    allowedFor,
  } = benefitBagConfig;
  return {
    id: benefitBagConfigId,
    periodicity: periodDurationInPayrolls,
    date: consumableFrom,
    amount: MonetaryAmount.ofCurrency(limitAmount).toUnitary(),
    canBeAccumulated: accumulableAtPeriodEnd,
    availableFor: allowedFor.map(({ benefit, config }) => ({
      name: benefit,
      config,
    })),
  };
}
